import type { SchemaBuilderFieldTitleProps } from "./schema-builder-field-title.type";

import { Typography } from "antd";

import { REGEXP_HTML_TAG } from "@/constants/RegExp";

const { Text } = Typography;

export const SchemaBuilderFieldTitle = ({
  schema,
}: SchemaBuilderFieldTitleProps) => {
  const { type, label } = schema;

  const text = type === "label" ? label.replace(REGEXP_HTML_TAG, " ") : label;

  return (
    <div className="schema-builder-field-label-preview">
      <Text ellipsis>{text}</Text>
    </div>
  );
};
